<template>
   <div>
      <template v-for="attribute in userAttributes">
         <user-attribute-chart v-if="isVisible(attribute)" :userId="userId" :attribute="attribute"></user-attribute-chart>
      </template>
   </div>
</template>


<script>
   import UserAttributeChart from "@/components/users/UserAttributeChart"

   export default {

      props: {
         userId: Number,
      },

      components: {
         UserAttributeChart,
      },

      mounted: async function() {
         this.userAttributes = await this.$store.dispatch('GET_USER_ATTRIBUTES', this.userId)
      },

      data () {
         return {
            userAttributes: null,
         }
      },

      computed: {
         user () {
            return this.$store.state.users[this.userId]
         }
      },

      methods: {
         isVisible (attribute) {
            if (attribute.params.acquisition === 'fitbit' && !this.user.extra.fitbit_user_id) return false
            return true
         },
      },
   }

</script>




// WEBPACK FOOTER //
// UserAttributeCharts.vue?ed966d6e